import _classCallCheck from "/home/runner/work/gear/gear/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/gear/gear/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { calcHead } from "./calcHead";
import { calcEyes, stabilizeBlink, calcPupils, calcBrow } from "./calcEyes";
import { calcMouth } from "./calcMouth";
/** Class representing face solver. */

export var FaceSolver = /*#__PURE__*/function () {
  function FaceSolver() {
    _classCallCheck(this, FaceSolver);
  }

  _createClass(FaceSolver, null, [{
    key: "solve",

    /**
     * Combines head, eye, pupil, and eyebrow calcs into one method
     * @param {Results} lm : array of results from tfjs or mediapipe
     * @param {String} runtime: set as either "tfjs" or "mediapipe"
     * @param {IFaceSolveOptions} options: options for face solver
     */
    value: function solve(lm) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref$runtime = _ref.runtime,
          runtime = _ref$runtime === void 0 ? "tfjs" : _ref$runtime,
          _ref$video = _ref.video,
          video = _ref$video === void 0 ? null : _ref$video,
          _ref$imageSize = _ref.imageSize,
          imageSize = _ref$imageSize === void 0 ? null : _ref$imageSize,
          _ref$smoothBlink = _ref.smoothBlink,
          smoothBlink = _ref$smoothBlink === void 0 ? false : _ref$smoothBlink,
          _ref$blinkSettings = _ref.blinkSettings,
          blinkSettings = _ref$blinkSettings === void 0 ? [] : _ref$blinkSettings;

      if (!lm) {
        console.error("Need Face Landmarks");
        return;
      } // set image size based on video


      if (video) {
        var videoEl = typeof video === "string" ? document.querySelector(video) : video;
        imageSize = {
          width: videoEl.videoWidth,
          height: videoEl.videoHeight
        };
      } //if runtime is mediapipe, we need the image dimentions for accurate calculations


      if (runtime === "mediapipe" && imageSize) {
        var _iterator = _createForOfIteratorHelper(lm),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var e = _step.value;
            e.x *= imageSize.width;
            e.y *= imageSize.height;
            e.z *= imageSize.width;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      var getHead = calcHead(lm);
      var getMouth = calcMouth(lm); //set high and low remapping values based on the runtime (tfjs vs mediapipe) of the results

      blinkSettings = blinkSettings.length > 0 ? blinkSettings : runtime === "tfjs" ? [0.55, 0.85] : [0.35, 0.5];
      var getEye = calcEyes(lm, {
        high: blinkSettings[1],
        low: blinkSettings[0]
      }); // apply blink stabilizer if true

      if (smoothBlink) {
        getEye = stabilizeBlink(getEye, getHead.y);
      }

      var getPupils = calcPupils(lm);
      var getBrow = calcBrow(lm);
      return {
        head: getHead,
        eye: getEye,
        brow: getBrow,
        pupil: getPupils,
        mouth: getMouth
      };
    }
  }]);

  return FaceSolver;
}();
/** expose blink stabilizer as a static method */

FaceSolver.stabilizeBlink = stabilizeBlink;